import { Link } from 'react-router-dom';
import { useApp } from '../state/AppContext';
import { relativeTime } from '../utils/format';

export function SystemsPage() {
  const { systems, loading } = useApp();

  return (
    <div className="page page-narrow">
      <h1>Connected systems</h1>
      <div className="page-sub">Every directory UDB reads from and writes to.</div>

      {loading && <div className="empty-state">Loading systems…</div>}

      <div className="systems-grid">
        {systems.map((system) => (
          <Link key={system.id} to={`/systems/${system.id}`} className="card system-card">
            <div className="system-card-head">
              <div className="sys-icon sys-icon-lg" style={{ background: system.color }}>
                {system.abbr}
              </div>
              <div className="system-card-title">
                <div className="system-card-name">{system.name}</div>
                <div className="system-card-cat">{system.category}</div>
              </div>
              {system.syncError ? (
                <span className="sync-badge sync-error" title={system.syncError}>
                  <span className="sync-dot" />
                  Sync error
                </span>
              ) : (
                <span className="sync-badge sync-ok">
                  <span className="sync-dot" />
                  Synced
                </span>
              )}
            </div>
            <div className="system-card-stats">
              <div>
                <div className="stat-value">{system.userCount}</div>
                <div className="stat-label">users</div>
              </div>
              <div>
                <div className="stat-value">{system.adminCount}</div>
                <div className="stat-label">admins</div>
              </div>
              <div>
                <div className="stat-value">{system.roles.length}</div>
                <div className="stat-label">roles</div>
              </div>
              <div className="stat-sync">
                <div className="mono muted">{relativeTime(system.lastSyncAt)}</div>
                <div className="stat-label">last sync</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
